module.exports = __webpack_public_path__ + "static/media/gcdef_10014.3bb6fd90.ico";